






































import { getArticles, deleteArticle, patchArticle } from '@/api/api';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import MetaDatatable from '@/models/MetaDatatable';
import Datatable from '@/components/Datatable.vue';
import { cloneDeep, get } from 'lodash';
import HeaderDatatable from '@/models/HeaderDatatable';

@Component({
    components: {
        Datatable
    },
    filters: {
        formatHour(date: string) {
            return moment(date).format('L');
        },
    }
})
export default class ArticlesDatatable extends Vue {
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 100,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: {
            prescriber: undefined,
            program: undefined,
            status: undefined,
            customer: undefined,
        },
    };
    meta: MetaDatatable = cloneDeep(this.defaultMeta);

    showEditArticle = false;

    article: any = {};

    @Prop() reload!: boolean;

    @Watch('reload')
    async onReloadChange(value: boolean, oldValue: boolean) {
        console.log(value)
        if (value == true) {
            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
            this.$emit('reloadSuccessfull');
        }
    }

    editArticle(article: any) {
        this.article = article;
        this.showEditArticle = true;
    }

    async patch() {
        this.actionDatatable({
            action: "edit",
            item: this.article
        })
    }

    deleteDialog(article: any) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: "Supprimer Article",
            text: "Souhaitez vous vraiment supprimer cet article",
            accept: () => this.acceptDeleteAlert(article),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    async acceptDeleteAlert(article: any) {
        await this.actionDatatable({ action: 'delete', item: article });
    }

    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: any | null;
    }) {
        const $vs = (this as any).$vs;
        const action = ev.action;
        const article: any | null = ev.item || null;
        switch (ev.action) {
            case 'edit':
                if (article && article.id) {

                    try {
                        const articleId = article.id
                        delete article.id
                        await patchArticle(article, articleId);

                        $vs.notify({
                            color: 'success',
                            position: 'top-right',
                            title: "Article modifié"
                        });

                        this.showEditArticle = false;
                        const $datatable = this.$refs.datatable as Datatable;
                        $datatable.refresh();

                    } catch (error) {
                        const message = get(
                            error,
                            'response.data.message',
                            `Erreur lors de la modification de l'article`
                        );

                        $vs.notify({
                            color: 'danger',
                            position: 'top-right',
                            title: 'Erreur',
                            text: message,
                        });
                    }
                }

                break;
            case 'delete':
                if (article && article.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                    };

                    try {
                        await deleteArticle(article.id);

                        $vs.notify({
                            color: 'success',
                            position: 'top-right',
                            title: "Article supprimé",
                            text: "",
                        });

                        const $datatable = this.$refs.datatable as Datatable;
                        $datatable.refresh();
                    } catch (error) {
                        const message = get(
                            error,
                            'response.data.message',
                            `Erreur lors de la suppression de l'option`
                        );

                        $vs.notify({
                            color: 'danger',
                            position: 'top-right',
                            title: 'Erreur',
                            text: message,
                        });
                    }
                }
                break;
        }
    }

    get columns(): HeaderDatatable[] {
        return [
            {
                title: 'Titre',
                dataIndex: 'label'
            },
            {
                title: 'Prix (HT / Mois)',
                dataIndex: 'price_ht',
                scopedSlots: {
                    customRender: 'price_ht',
                },
            },
            {
                title: 'Actions',
                dataIndex: 'action',
                scopedSlots: {
                    customRender: 'actions',
                },
                fixed: 'right',
            },
        ];
    }

    async fetch(meta: MetaDatatable) {
        const { data } = await getArticles({
            ...meta,
            page: meta.page - 1,
        });
        return data;
    }

}
